import api from './api';

// Contract for the followup-approval flow (updated spec, 18/08/2026).
// Backend data source (IL-system proxy vs synced table) is pending Shachar's
// decision - the portal-side contract stays the same either way.

export interface FollowupCandidate {
  patient_id: number;
  first_name: string;
  last_name: string;
  hm_id: string;
  id_number: string;
  phone: string;
  psy_meeting_date: string; // ISO date of the psy intake meeting
  summary_pdf_available: boolean;
}

export async function getFollowupCandidates(): Promise<FollowupCandidate[]> {
  const res = await api.get('/leads/followup-candidates');
  return res.data;
}

export function summaryPdfUrl(patientId: number): string {
  const base = process.env.REACT_APP_API_URL || '';
  return `${base}/leads/followup-candidates/${patientId}/summary-pdf`;
}

export async function submitFollowupObligation(
  patientId: number,
  obligationNumber: string
): Promise<void> {
  await api.post(`/leads/followup-candidates/${patientId}/obligation`, {
    obligation_number: obligationNumber,
  });
}
